export interface ModuleDef {
  id: string;
  label: string;
  category: string;
}

// Single source of truth for every module a Member can be invited to.
// Keep in sync with the backend's ALL_MODULES list and Sidebar.tsx's nav categories.
export const ALL_MODULES: ModuleDef[] = [
  { id: 'overview', label: 'Overview', category: 'General' },
  { id: 'scorecard', label: 'Scorecard', category: 'General' },
  { id: 'dtc-kpis', label: 'DTC KPIs', category: 'General' },
  { id: 'meta-ads', label: 'Meta Ads', category: 'Revenue Ops' },
  { id: 'shopify', label: 'Shopify DTC', category: 'Revenue Ops' },
  { id: 'google-ads', label: 'Google Ads', category: 'Revenue Ops' },
  { id: 'hubspot', label: 'HubSpot', category: 'B2B' },
  { id: 'design-tracker', label: 'Design Tracker', category: 'Design' },
  { id: 'shopify-merch', label: 'Shopify Merch KPIs', category: 'Merchandising' },
  { id: 'category-ops', label: 'Category Ops Sheet', category: 'Merchandising' },
  { id: 'unicommerce', label: 'Unicommerce', category: 'Warehouse' },
  { id: 'zoho', label: 'Zoho Books', category: 'Finance' },
  { id: 'bitespeed', label: 'Bitespeed', category: 'CX' },
  { id: 'shopify-tags', label: 'Shopify Tags', category: 'CX' },
];
